import React from 'react'
import PrivacyPolicy from '../fetures/privacy-policy/PrivacyPolicy'

const PrivacyPolicyPage = () => {
  return (
    <PrivacyPolicy/>
  )
}

export default PrivacyPolicyPage